var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1140,
    height: 600,
    viewBox: "0 0 475 250",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h475v250H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7500",
    d: "M0 242V0h475v53z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#003893",
    d: "M0 238V0h475v4zm0 8v4h475V102z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m91.28 13.78 3.2 53.21 11.16-29.32-4.99 30.97 18.38-25.43-12.84 28.63 24.33-19.81-19.8 24.33 28.62-12.83-25.43 18.37 30.98-4.99-29.32 11.17 53.21 3.2-53.21 3.2 29.32 11.16-30.98-4.99 25.43 18.38-28.62-12.84 19.8 24.33-24.33-19.8 12.84 28.62-18.38-25.43 4.99 30.98-11.16-29.32-3.2 53.21-3.2-53.21-11.17 29.32 4.99-30.98-18.37 25.43 12.83-28.62-24.33 19.8 19.81-24.33-28.63 12.84 25.43-18.38-30.97 4.99 29.32-11.16-53.21-3.2 53.21-3.2-29.32-11.17 30.97 4.99-25.43-18.37 28.63 12.83-19.81-24.33 24.33 19.81-12.83-28.63L81.9 68.64l-4.99-30.97 11.17 29.32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMh);
export default __webpack_public_path__ + "static/media/mh.2b7af5085b860d991480305eca150ef0.svg";
export { ForwardRef as ReactComponent };